import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=7580aeee&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=7580aeee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580aeee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7580aeee')) {
      api.createRecord('7580aeee', component.options)
    } else {
      api.reload('7580aeee', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=7580aeee&scoped=true&", function () {
      api.rerender('7580aeee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bfTI6yxuoN0p/JS/comp/PopupDialog.vue"
export default component.exports